var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import Button from '@web/components/layout/Button';
import Modal, { ModalSize } from '@web/components/layout/Modal';
import { ActivityLabelModal } from '@web/components/Settings/ActivityLabels/ActivityLabelModal';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
var GeneratedLabelsModal = function (_a) {
    var visible = _a.visible, labels = _a.labels, onClose = _a.onClose, onSave = _a.onSave;
    var t = useTranslation().t;
    var _b = useState([]), acceptedLabels = _b[0], setAcceptedLabels = _b[1];
    var _c = useState(null), editingLabel = _c[0], setEditingLabel = _c[1];
    var _d = useState([]), labelsList = _d[0], setLabelsList = _d[1];
    useEffect(function () {
        var mapped = labels.map(function (label, index) { return (__assign(__assign({}, label), { id: index + 1 })); });
        setLabelsList(mapped);
        setAcceptedLabels(mapped);
    }, [labels]);
    var handleAccept = function (label) {
        if ((editingLabel === null || editingLabel === void 0 ? void 0 : editingLabel.name) === label.name) {
            setEditingLabel(null);
        }
        setAcceptedLabels(function (prev) {
            if (prev.some(function (l) { return l.name === label.name; })) {
                return prev.filter(function (l) { return l.name !== label.name; });
            }
            return __spreadArray(__spreadArray([], prev, true), [label], false);
        });
    };
    var handleDelete = function (label) {
        setLabelsList(function (prev) {
            var newList = prev.filter(function (l) { return l.id !== label.id; });
            if (newList.length === 0) {
                setTimeout(function () { return onClose(); }, 0);
            }
            return newList;
        });
    };
    var isLabelAccepted = function (label) {
        return acceptedLabels.some(function (l) { return l.name === label.name; });
    };
    var handleSave = function () {
        var labelsWithoutIds = acceptedLabels.map(function (_a) {
            var id = _a.id, label = __rest(_a, ["id"]);
            return label;
        });
        setAcceptedLabels([]);
        onSave(labelsWithoutIds);
    };
    return (_jsxs(Modal, __assign({ visible: visible, onClose: onClose, size: ModalSize.XXL }, { children: [_jsx("div", __assign({ className: "space-y-4 max-h-[65vh] overflow-y-auto overflow-x-hidden pr-1" }, { children: labelsList.map(function (label) {
                    return label.id === (editingLabel === null || editingLabel === void 0 ? void 0 : editingLabel.id) ? (_jsx("div", { children: _jsx(ActivityLabelModal, { visible: true, onClose: function () { return setEditingLabel(null); }, label: label, onSave: function (updatedLabel) {
                                var newLabelsList = labelsList.map(function (l) {
                                    return l.id === label.id ? __assign(__assign({}, updatedLabel), { id: label.id }) : l;
                                });
                                setLabelsList(newLabelsList);
                                setEditingLabel(null);
                            } }) }, label.id)) : (_jsxs("div", __assign({ className: "flex items-center justify-between p-4 border rounded-lg gap-5 min-w-0" }, { children: [_jsxs("div", __assign({ className: "space-y-2 min-w-0 flex-1" }, { children: [_jsx("h3", __assign({ className: "font-medium" }, { children: label.name })), _jsx("div", __assign({ className: "text-sm text-gray-500 break-words [word-break:normal] whitespace-normal" }, { children: label.rules.map(function (rule, index) { return (_jsxs("div", __assign({ className: "mt-1" }, { children: [rule.conditions.map(function (condition, condIndex) { return (_jsxs("span", { children: [t("app.settings.activityLabels.targets.".concat(rule.target)), ' ', t("app.settings.activityLabels.conditionTypes.".concat(condition.type)), ' ', "\"", condition.keyword, "\"", condIndex < rule.conditions.length - 1
                                                            ? ' AND '
                                                            : ''] }, condIndex)); }), index < label.rules.length - 1 ? ', ' : ''] }), index)); }) }))] })), _jsxs("div", __assign({ className: "flex gap-3 self-end" }, { children: [_jsx("input", { type: "checkbox", checked: isLabelAccepted(label), onChange: function () { return handleAccept(label); }, className: "w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" }), _jsx(PencilIcon, { className: "h-5 w-5 text-indigo-600 cursor-pointer hover:text-indigo-800 hover:scale-105", onClick: function () { return setEditingLabel(label); } }), _jsx(TrashIcon, { className: "h-5 w-5 text-indigo-600 cursor-pointer hover:text-indigo-800 hover:scale-105", onClick: function () { return handleDelete(label); } })] }))] }), label.id));
                }) })), _jsx("div", __assign({ className: "flex justify-end" }, { children: _jsxs("div", __assign({ className: "flex mt-5 gap-5" }, { children: [_jsx(Button, __assign({ variant: "white", onClick: function () {
                                setAcceptedLabels([]);
                                onClose();
                            } }, { children: t('button.cancel') })), _jsxs(Button, __assign({ variant: "primary", onClick: handleSave, disabled: acceptedLabels.length === 0 }, { children: [t('button.save'), " (", acceptedLabels.length, ")"] }))] })) }))] })));
};
export default GeneratedLabelsModal;
